export enum SuggestionType {
    SUGGESTION = 'SUGGESTION',
    COMPLAINT = 'COMPLAINT',
    OBJECT_LOST = 'OBJECT_LOST',
}